import React, { useState, useEffect } from 'react';
import { Box, Text, Flex, Badge } from '@radix-ui/themes';
import CircleProgress from '../../shared/CircleProgress';

const CourseReport = ({ course_report, onQuizSelected }) => {
    const [selectedQuiz, setSelectedQuiz] = useState(null);
    console.log('course_report::', course_report);
    //course->[subject, level, teaching_plans->quizzes->quiz_attempts]

    return (
        <Flex direction="column" gap="3">
            <Text weight="bold" size="3">
                {course_report.subject.name} - {course_report.level.name}
            </Text>
            {course_report.teaching_plans.map(plan => (
                <Box key={plan.id}>
                    {plan.quizzes.map(quiz => {
                    const attempts = quiz.quiz_attempts || [];
                    return (
                        <Box key={quiz.id} p="3" style={{backgroundColor: selectedQuiz?.id === quiz.id ? 'var(--gray-3)' : 'transparent', cursor: 'pointer', borderBottom: '1px solid var(--gray-4)' }}
                            onClick={() => { setSelectedQuiz(quiz); onQuizSelected?.(quiz)}}
                        >
                            <Flex justify="between" align="center">
                                <Flex direction="column" gap="1">
                                    <Text weight="bold" size="2">Quiz #{quiz.id}</Text>
                                    <Text size="1" color="gray">
                                        {attempts.length} {attempts.length === 1 ? 'attempt' : 'attempts'}
                                    </Text>
                                </Flex>
                                {attempts.length > 0 && (
                                    <CircleProgress
                                        progress={attempts[attempts.length - 1].percentage}
                                        size={40}
                                        label={`${Math.floor(attempts[attempts.length - 1].percentage)}%`}
                                        labelSize="1"
                                    />
                                )}
                            </Flex>
                            {attempts.length > 0 && (
                                <Flex gap="2" mt="2">
                                    <Badge color="blue">
                                        Vocab: {Math.floor(attempts[attempts.length - 1].vocabulary_score)}%
                                    </Badge>
                                    <Badge color="violet">
                                        Concept: {Math.floor(attempts[attempts.length - 1].concept_score)}%
                                    </Badge>
                                    <Badge color="green">
                                        Apply: {Math.floor(attempts[attempts.length - 1].application_score)}%
                                    </Badge>
                                </Flex>
                            )}
                        </Box>
                    );
                })}
            </Box>
        ))}
        </Flex>
    );
};

export default CourseReport;
